package org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontLineHeight
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.VerticalScrollBehavior
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.closing_reports.CurrencyTypeEnum
import org.hs_soft.runmynesto.domain.model.home.product.products_list_model.ProductItem
import org.hs_soft.runmynesto.domain.model.home.template.TemplateInfoHeaderEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.ArticleSortEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.ListingLayoutsEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.WaiterDeviceTypeEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.MonthModel
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.template_category_detail.GetCategory
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.Children
import org.hs_soft.runmynesto.pages.components.TopTabItems
import org.hs_soft.runmynesto.pages.components.checkout.CheckoutTabContent
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.TabTemplateGeneralContent
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_options.TemplateOptionContent
import org.jetbrains.compose.web.css.px


@Composable
fun TemplateContent(
    modifier: Modifier = Modifier,
    selectedTab: TemplateInfoHeaderEnum,
    selectedWaiterDeviceType: WaiterDeviceTypeEnum,
    selectedWaiterLayoutType: ListingLayoutsEnum,
    checkOutData: List<Children>?,
    countryId: String,
    selectedCategory: GetCategory?,
    isCheckoutExpandAll: Boolean,
    priceLevelList: List<String?>,
    imgUrl: String?,
    selectedDays: Int,
    selectedArticleSortingId: String,
    selectedDate: MonthModel,
    windowSizeMode: WindowSizeModeEnum,
    articleList: List<ProductItem>,
    showTitleSortIcon: Boolean,
    checkoutSearchValue: String,
    currencyType: CurrencyTypeEnum,
    articleColumnsCount: Int,
    articleRowsCount: Int,
    selectedPriceLevelIndex: Int?,
    selectedColor: String?,
    openColorPanel: () -> Unit,
    onCheckoutSearch: (String) -> Unit,
    updateTemplateCheckout: (MutableSet<String>) -> Unit,
    onRefreshClick: () -> Unit,
    updateArticleRowsCount: (Int, Int) -> Unit,
    onSearchValueChange: (String) -> Unit,
    onTitleSortClick: () -> Unit,
    onChangeActivity: (String, Boolean) -> Unit,
    onChangeReceiptName: (String, String) -> Unit,
    onTabClick: (TemplateInfoHeaderEnum) -> Unit,
    getPriceLevels: () -> Unit,
    updatePriceLevel: (Int) -> Unit,
    updateSurcharge: (String, List<Int?>) -> Unit,
    setCalendarStatus: (Boolean) -> Unit,
    onChangeDayCheckStatus: (Int) -> Unit,
    onAddProductIconClick: () -> Unit,
    onDeviceTypeClick: (WaiterDeviceTypeEnum) -> Unit,
    onShowLayoutTypeClick: (ListingLayoutsEnum) -> Unit,
    showImgAIGeneratorDialog: () -> Unit,
    updateProductListAfterDragAndDrop: (List<dynamic>, List<String>, List<Int>, List<String>) -> Unit,
    showImgUrl: suspend (String) -> String,
    deleteGridProduct: (Int) -> Unit,
    setGridProduct: (String, Int) -> Unit,
    selectArticleSorting: (ArticleSortEnum) -> Unit,

    ) {
    Column(
        modifier=modifier
            .margin(
                left = if (windowSizeMode== WindowSizeModeEnum.PHONE)
                    0.px
                else Dimen.mediumPadding,
            )
            .overflow(Overflow.Auto)
            .fillMaxSize(),
        horizontalAlignment = Alignment.Start
    )
    {
        SpanText(
            text=selectedCategory?.name?:"",
            modifier = Modifier
                .minHeight(Dimen.minimumContentTitleHeight)
                .fontSize(FontSizes.extraExtraLargeFontSize)
                .margin(left = Dimen.normalPadding)
                .fontWeight(FontWeight.Normal)
                .lineHeight(FontLineHeight.lineLarge)
                .color(Theme.TextPrimary.rgb)
                .fontFamily(FontFamily.Jakarta)
        )

        TopTabItems(
            windowSizeMode=windowSizeMode,
            selectedTab=selectedTab,
            tabItems = TemplateInfoHeaderEnum.entries,
            onTabClick={
                onTabClick(it)
            }
        )


        when(selectedTab)
        {
            TemplateInfoHeaderEnum.GENERAL->{

                TabTemplateGeneralContent(
                    modifier = VerticalScrollBehavior
                        .toModifier(),
                    currencyType=currencyType,
                    selectedWaiterDeviceType = selectedWaiterDeviceType,
                    selectedWaiterLayoutType = selectedWaiterLayoutType,
                    showTitleSortIcon = showTitleSortIcon,
                    titleSorting = true,
                    selectedArticleSortingId=selectedArticleSortingId,
                    selectedDays = selectedDays,
                    selectedDate=selectedDate,
                    windowSizeMode = windowSizeMode,
                    articleList = articleList,
                    articleColumnsCount=articleColumnsCount,
                    articleRowsCount=articleRowsCount,
                    imgUrl = imgUrl,
                    selectedColor = selectedColor,
                    selectedCategory = selectedCategory,
                    onChangeActivity = {infoId,it->
                        onChangeActivity(infoId,it)
                    },
                    onChangeReceiptName ={infoId,it->
                        onChangeReceiptName(infoId,it)
                    } ,
                    onRefreshClick = {
                        onRefreshClick()
                    },
                    onSearchValueChange = {
                        onSearchValueChange(it)
                    },
                    onTitleSortClick ={
                        onTitleSortClick()
                    } ,
                    setCalendarStatus = {
                        setCalendarStatus(it)
                    },
                    openColorPanel = {
                        openColorPanel()
                    },
                    onChangeDayCheckStatus = {
                        onChangeDayCheckStatus(it)
                    },
                    showImgAIGeneratorDialog = {
                        showImgAIGeneratorDialog()
                    },
                    updateListAfterDragAndDrop = { newList,idList,positionList,productIdList ->
                        updateProductListAfterDragAndDrop(
                            newList,idList,positionList,productIdList
                        )
                    },
                    onAddProductIconClick = {
                        onAddProductIconClick()
                    },
                    onShowLayoutTypeClick = {
                        onShowLayoutTypeClick(it)
                    },
                    onDeviceTypeClick = {
                        onDeviceTypeClick(it)
                    },
                    showImgUrl = {key->
                        showImgUrl(key)
                    },
                    deleteGridProduct = {position:Int->
                        deleteGridProduct(position)
                    },
                    setGridProduct = {productId:String,position:Int->
                        setGridProduct(productId,position)
                    },
                    selectArticleSorting = {
                        selectArticleSorting(it)
                    },
                    updateArticleRowsCount = {rows,columns->
                        updateArticleRowsCount(rows,columns)
                    }
                )
            }

            TemplateInfoHeaderEnum.CHECKOUT->{
                CheckoutTabContent(
                    windowSizeMode =windowSizeMode,
                    cashList =checkOutData,
                    cashRegisterIds = selectedCategory?.cashRegisterId,
                    updateCheckout = {
                        updateTemplateCheckout(it)
                    },
                    isExpandAll = isCheckoutExpandAll,
                    searchValue = checkoutSearchValue,
                    onSearchValueChange = {
                        onCheckoutSearch(it)
                    },

                )
            }


//            TemplateInfoHeaderEnum.SURCHARGE_IN_HOUSE->{
//
//                SurchargeInHouse(
//                    windowSizeMode=windowSizeMode,
//                    surchargeFrom=selectedCategory?.surchargeFrom,
//                    surchargeAmount=selectedCategory?.surchargeAmount,
//                    surchargePercent=selectedCategory?.surchargePercent,
//                    updateSurcharge = {fieldTitle,newList->
//                        updateSurcharge(fieldTitle,newList)
//                    }
//                )
//
//            }
//
            TemplateInfoHeaderEnum.OPTIONS->{

                TemplateOptionContent(
                    priceLevelList = priceLevelList,
                    selectedIndex = selectedPriceLevelIndex,
                    countryId = countryId,
                    getPriceLevels = {
                        getPriceLevels()
                    },
                    updatePriceLevel = {
                        updatePriceLevel(it)
                    },
                    surchargePercent=selectedCategory?.surchargePercent,
                    updateSurcharge = {fieldTitle,newList->
                        updateSurcharge(fieldTitle,newList)
                    }
                )



            }

        }



    }




}

